


































import { Component, Emit, Vue } from 'vue-property-decorator'
import { ExtendedRouteConfig, ExtendedRouter, RouteGroup } from '@/types/routing-types'
import NavigationItem from '@/components/layout/NavigationItem.vue'
import { routeGroupName } from '@/routes'


interface RouteGroupInfo {
    key: RouteGroup;
    name: string;
}


@Component({
    components: {
        NavigationItem
    }
})
export default class SidePanel extends Vue {
    get routes(): Array<ExtendedRouteConfig> {
        return (this.$router as ExtendedRouter).options.routes
    }

    get defaultRoutes(): ExtendedRouteConfig[] {
        return this.getGroupRoutes(RouteGroup.DEFAULT)
    }

    getGroupRoutes(group: RouteGroup): ExtendedRouteConfig[] {
        const routes = []
        for (const route of this.routes) {
            if (route.meta.group === group) {
                routes.push(route)
            }
        }
        return routes
    }

    get routeGroups(): RouteGroupInfo[] {
        const routeGroups = []
        for (const key in RouteGroup) {
            if (Object.prototype.hasOwnProperty.call(RouteGroup, key)) {
                const group: RouteGroup = RouteGroup[key as keyof typeof RouteGroup]
                if (group !== RouteGroup.DEFAULT) {
                    const name: string = routeGroupName[group]
                    routeGroups.push({ key: key as unknown as RouteGroup, name })
                }
            }
        }
        return routeGroups
    }

    @Emit('close-drawer')
    async logout() {
        await this.$store.dispatch('clearAuthToken')
        // eslint-disable-next-line no-self-assign
        // window.location.href = window.location.href
    }
}
